import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';

@Injectable()
export class CompanyLanguagesHttpService extends BaseHttpService {

  constructor(httpClient: HttpClient) {
    super(httpClient, '/companies');
  }

  /* ============================
     Get All Languages for Company
     GET /api/v3/companies/:id/company-languages/
  ============================ */

  public getAllLanguages(companyId: number) {
    return this.get(`/${companyId}/company-languages/`).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  /* ============================
     Get Selected Languages
     GET /api/v3/companies/:id/selected-company-languages/
  ============================ */

  public getSelectedLanguages(companyId: number | string) {
    return this.getCampaign(`/${companyId}/selected-company-languages/`).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  /* ============================
     Add Selected Languages
     POST
     Payload:
     [
       { lang_name: 'English', lang_code: 'en' }
     ]
  ============================ */

  public addLanguages(
    companyId: number,
    payload: any[]
  ) {
    return this.post(`/${companyId}/selected-company-languages/`, payload).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  /* ============================
     Update Selected Languages
     PUT
     Same payload as POST
  ============================ */

  public updateLanguages(
    companyId: number,
    payload: any[]
  ) {
    return this.put(`/${companyId}/selected-company-languages/`, payload).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
}
